import { Component, Input } from '@angular/core';

let nextClusterId = 0;

@Component({
  selector: 'app-signup-form-cluster',
  standalone: true,
  imports: [],
  templateUrl: './signup-form-cluster.component.html',
  styleUrls: ['./signup-form-cluster.component.css'],
})
export class SignupFormClusterComponent {
  @Input({ required: true }) title = '';
  @Input() helperText?: string;
  protected readonly titleId = `cluster-title-${nextClusterId++}`;
}
